import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePage } from '../PageContext';
import { cuurentNextYear,setDateRange,formatDate,DownloadFile } from './Function';
import { Row, Col, Card,ListGroup, Placeholder, Button,Table,Tabs,Tab } from 'react-bootstrap';
const ProgramDetails = ({ htaccess }) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const [isLoading, setLoading] = useState(true);
    const [Programs, setPrograms] = useState([]);
    useEffect(() => {
        const ProgramsDetails = async () => {
      try {
        const response = await fetch(global.config.API_URL + "programs/details/" + htaccess);
        const result = await response.json();
        if (result.length > 0) {
          Promise.all(
            result.map(e => {
              const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.p_id + "/programImage")
                .then(upp => upp.json());
              const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.p_id + "/programImageHi")
                .then(upb => upb.json());
              return Promise.all([fetch1, fetch2])
                .then(([upp, upb]) => {
                  return {
                    ...e,
                    upp,
                    upb
                  };
                });
            })
          ).then(allResponse => {
            allResponse.forEach((el, i) => {
              result[i].programImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
              result[i].programImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
            });
            setPrograms(result[0]);
            currentPage(result[0]);
          }).catch(error => {
            console.error('Programs Image :', error);
          });
        }
        if (global.config.IsPrint === true) { console.info('ProgramsDetails : Result', result); }
      } catch (error) {
        console.error('ProgramsDetails : Error', error.message);
      } finally {
        setLoading(false);
      }
    };    
    ProgramsDetails();
    // eslint-disable-next-line
  }, [htaccess]);
  return (
    <React.Fragment>
      {isLoading ? (
        <Card className='bg-secondary-subtle text-center'>
            <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500">
                <Placeholder xs={10} />
            </Card.Header>
            <Card.Body>
            </Card.Body>
        </Card>
      ) : (
        <React.Fragment>
            <Card className='bg-secondary-subtle text-center mb-4'>
            <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500">
                {appLanguage === 'hi' ? 'प्रोग्राम के बारे में' : 'About the program'}
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col md={9} className='text-start'>
                        <h4>
                        {appLanguage === 'hi' ? Programs.p_name_hi || Programs.p_name : Programs.p_name}
                        {Programs.programType && (
                        appLanguage === 'hi'
                            ? ' (' + (Programs.programType?.pt_name_hi || Programs.programType?.pt_name) + ')'
                            : ' (' + Programs.programType?.pt_name + ')'
                        )}
                        {Programs.programType?.programGroup && (
                        appLanguage === 'hi'
                            ? ' - ' + (Programs.programType?.programGroup?.pg_name_hi || Programs.programType?.programGroup?.pg_name)
                            : ' - ' + Programs.programType?.programGroup?.pg_name
                        )}
                        </h4>
                        <div dangerouslySetInnerHTML={{__html:appLanguage === 'hi' ? Programs.p_detail_hi || Programs.p_detail : Programs.p_detail}}></div>
                    </Col>
                    <Col md={3}>
                        <Card className='text-bg-info'>
                        <Card.Body className='p-2'>
                            <Card.Img src={appLanguage === 'hi' ? Programs.programImageHi || Programs.programImage : Programs.programImage} />
                        </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Card.Body>
            </Card>
            <Card className='bg-secondary-subtle text-center mb-4'>
            <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500">
                {appLanguage === 'hi' ? 'प्रवेश प्रक्रिया' : 'Admission Process'}
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col md={3}>
                    <Card className='text-center h-100 shadow-sm'>
                        <Card.Header className='flex-grow-1 d-flex align-items-center justify-content-center fw-bold text-bg-info bg-info-subtle'>
                            {appLanguage === 'hi' ? Programs.p_name_hi || Programs.p_name : Programs.p_name}
                        </Card.Header>
                        { Programs.p_intake > 0 && <ListGroup variant="flush">
                                                <ListGroup.Item className='text-nowrap'>{appLanguage === 'hi' ? 'समयांतराल:' : 'Duration:'} {Programs.p_duration} {appLanguage === 'hi' ? 'वर्ष' : 'Year'}</ListGroup.Item>
                                                <ListGroup.Item className='text-nowrap'>{appLanguage === 'hi' ? 'प्रवेश:' : 'Intake:'} {Programs.p_intake}</ListGroup.Item>
                                            </ListGroup>
                        }
                    </Card>
                    </Col>
                    <Col md={9} className='text-start'>
                        <div dangerouslySetInnerHTML={{__html:appLanguage === 'hi' ? Programs.programType?.pt_admission_procedure_hi || Programs.programType?.pt_admission_procedure : Programs.programType?.pt_admission_procedure}}></div>
                        <div className='d-flex align-items-center'>
                            {Programs.programType?.pt_id && <ProgramBrochure ptId={Programs.programType?.pt_id} />}
                            {Programs.programType?.pt_admission_link && <a href={Programs.programType?.pt_admission_link} className='mt-3 btn btn-info' target='_blank' rel="noreferrer">
                                {appLanguage === 'hi' ? 'प्रवेश पोर्टल के लिए लिंक' : 'Link to Admission Portal'}<br />{cuurentNextYear()}
                            </a> } 
                        </div>
                    </Col>                
                </Row>
            </Card.Body>
            </Card>
            {Programs.p_id && <SchemeSyllabusByProgram pId={Programs.p_id} programName={Programs.programType && (
                    appLanguage === 'hi'
                        ? (Programs.programType?.pt_name_hi || Programs.programType?.pt_name) + ' ('+Programs.p_short_name_hi || Programs.p_short_name+')'
                        : Programs.programType?.pt_name+ ' ('+Programs.p_short_name+')'
                    ) } />}
                
            {Programs.p_id && Programs.programType?.pt_id && <ProgramPso ptId={Programs.programType.pt_id} pId={Programs.p_id} /> }
                
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default ProgramDetails;
const ProgramBrochure = ({ptId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Brochure,setBrochure]=useState([]);
    useEffect(()=>
    {
        const getBrochure = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL + "upload/details/0/" + ptId + "/ptBrochure");
                const result = await response.json();
                setBrochure(result);
                if( global.config.IsPrint === true ) { console.info('getBrochure : Result',result); }
                
            } catch (error) 
            {
                console.error('getBrochure : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        getBrochure();   
    },[ptId])
    return (
        <React.Fragment>
            {isLoading ? (
                <Button className='btn btn-info w-25 mt-3 me-3'>Admission Brochure<br />
                    <Placeholder xs={10} />
                    <Placeholder xs={8} />
                </Button>
            ) : (
                <React.Fragment>
                    {Brochure.map((up,index)=>(
                        <a href={global.config.uploadPath+up.up_fname+up.up_ext} className='btn btn-info mt-3 me-3' target='_blank' rel="noreferrer" key={index}>
                            {appLanguage === 'hi' ? 'प्रवेश ब्रोशर' : 'Admission Brochure'}<br />{cuurentNextYear()}
                        </a>
                    ))}
                </React.Fragment>
            )}
        </React.Fragment>    
    );
}
const SchemeSyllabusByProgram = ({pId,programName}) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[SchemeSyllabus,setSchemeSyllabus]=useState([]);
    useEffect(() => 
    {
        SchemeSyllabusList();
        // eslint-disable-next-line
    }, [pId]);
    const SchemeSyllabusList = async () => 
    {
        try 
        {
            const { startDate, endDate } = setDateRange(0, 0, 1, 0, 0);
            const callApi = global.config.API_URL + `schemeSyllabus/list/${pId}/0/0/${startDate}/${endDate}`;
            if(global.config.IsPrint) console.info('SchemeSyllabusList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ps_id+"/psSyllabus")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ps_id+"/psSyllabusHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].psSyllabus = el.upp;
                        result[i].psSyllabusHi = el.upph;                            
                    });
                    setSchemeSyllabus(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('SchemeSyllabusList: Error', error);
                    setLoading(false);
                });
            } else {
                setSchemeSyllabus([]);
                setLoading(false);
            }            
            if( global.config.IsPrint === true ) { console.info('SchemeSyllabusList : Result',result); }
        }
        catch (error) { 
            console.error('SchemeSyllabusList : Error', error.message);
            setLoading(false);
        }
    };
    return (
    <React.Fragment>
        <Card className='mb-3'>
            <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500">
                {programName}
            </Card.Header>
            <Card.Body>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                <thead>
                    <tr>
                        <th className="w-50">{appLanguage === 'hi' ? 'पाठ्यक्रम (वर्षवार)' : 'Syllabus (Year-Wise)'}</th>
                        <th>{t('UploadDate')}</th>
                        <th>{t('Download')}</th>
                    </tr>
                </thead>
                {isLoading ? (
                <tbody>
                    {[...Array(5)].map((_, index) => (
                    <tr key={index}>
                        <th className="table-success"><Placeholder xs={12} /></th>
                        <td><Placeholder xs={12} /></td>
                        <td className="text-center"><Button className="btn btn-light w-75"><Placeholder xs={12} /></Button></td>                
                    </tr>
                    ))}
                </tbody>
                ) : (
                <tbody>
                    {SchemeSyllabus.map((ps,index)=>(
                    <tr key={index}>
                        <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (ps.ps_display_en === "1" ? ps.ps_name_hi || '' : ps.ps_name_hi || ps.ps_name) : ps.ps_name}}></th>
                        <td>{formatDate(ps.ps_date)}</td>
                        <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,ps.psSyllabus,ps.psSyllabusHi)}} />                
                    </tr>
                    ))}
                </tbody>
                )}
                </Table>
            </Card.Body>
        </Card>
        
    </React.Fragment>
    );
}
const ProgramPso = ({ptId,pId}) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const eArray = {1:'PSO',2:'PEO'};
    const hArray = {1:'पीएसओ',2:'पीईओ'};
    const[Pseo,setPseo]=useState([]);
    const[seLoading, setSeLoading] = useState(true);
    useEffect(() => 
    {
        const PseoByProgram = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departmentsPseo/byProgram/"+ptId+'/'+pId);
                const result = await response.json();
                setPseo(result);
                setSeLoading(false);               
                if( global.config.IsPrint === true ) { console.info('PseoByProgram : Result',result); }
            } catch (error) 
            {
                console.error('PseoByProgram : Error', error.message);
                setSeLoading(false);
            }
        };
        PseoByProgram();
        // eslint-disable-next-line
    }, [ptId,pId]);
    const groupedData = Pseo.reduce((acc, item) => 
    {
        const pp_type = item.pp_type;
        if (!acc[pp_type]) {
            acc[pp_type] = [];
        }
        acc[pp_type].push(item);
        //console.info('PSOO',acc);
        return acc;
        
    }, {});
    return (
        <div className='py-3 text-center'>
            <h3>{ appLanguage === 'hi' ? 'पीओ/पीएसओ/पीईओ' : 'PO/PSO/PEO'}</h3>
            <span className="mx-auto mb-0 sub-heading"></span>
            {!seLoading && <Tabs defaultActiveKey="0">
            {Object.entries(groupedData).map(([_, items], index) => (                    
                <Tab 
                eventKey={index} 
                key={index} 
                className='text-start' 
                title={ appLanguage === 'hi' ? hArray[items[0].pp_type] : eArray[items[0].pp_type] }
                >
                {items
                    .filter(item => item.pp_type === 1)
                    .sort((a, b) => a.pp_sequence - b.pp_sequence)
                    .map((item, index) => (
                    <div key={index} className='d-flex mb-2'>
                        <div className='text-decoration-underline'>{ appLanguage === 'hi' ? 'पीएसओ' + (index + 1) + ':' : 'PSO' + (index + 1) + ':'}</div>                                        
                        <div className='ms-2' dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? item.pp_content_hi : item.pp_content }} />
                    </div>
                ))}
                {items
                    .filter(item => item.pp_type === 2)
                    .sort((a, b) => a.pp_sequence - b.pp_sequence)
                    .map((item, index) => (
                    <div key={index} className='d-flex mb-2'>
                        <div className='text-decoration-underline'>{ appLanguage === 'hi' ? 'पीईओ' + (index + 1) + ':' : 'PEO' + (index + 1) + ':'}</div>
                        <div className='ms-2' dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? item.pp_content_hi : item.pp_content }} />
                    </div>
                ))}                        
                </Tab>
            ))}
            </Tabs>}                        
        </div>        
    );
}
